














import { Vue, Component, Prop } from "vue-property-decorator";
import { screenWidth } from "@/plugins/variables";

@Component({
  computed: {
    screenWidth: screenWidth
  }
})
export default class textField extends Vue {
  @Prop() label!: string;
  @Prop() value!: string | any;
  @Prop({ default: true }) limitedString!: boolean;
  @Prop({ default: false }) passive!: boolean;
  @Prop({ default: 200 }) leftBlockWidth?: number;
  get blockWidth() {
    return screenWidth() > 1279 ? `width: ${this.leftBlockWidth}px` : "";
  }

  get convertSymbols() {
    return this.$converter.limitedOutput(this.value, 40);
  }
}
